import React, { useEffect } from "react";
import type { RootState } from "app/store";
import { action, useDsp, useSlc } from "app/store";
import RedirectTo from "components/RedirectTo/RedirectTo";
import { useParams } from "react-router-dom";
import { ReactComponent as IconGallery } from "assets/images/icon-gallery.svg";
import PhotoAlbum from "react-photo-album";
import { apiFriendGallery } from "app/api";
import { LinkActionBack } from "components/link";
import { RenderUserPhoto } from "./_renderPhoto";

export const SomeGallery = () => {
  const dispatch = useDsp();
  const isAuth = useSlc((state: RootState) => state.user.isAuth);
  const { id }: any = useParams() || "";

  const photos = useSlc((state: RootState) => state.galleryList) || [];
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const smallPhotos = photos.map(({ original, small }: any) => ({
    src: baseurl + original.url,
    width: original.width,
    height: original.height,
    title: baseurl + small.url,
  }));
  // console.log("GALLERY", smallPhotos);

  const apiSuccess = ({ data, status }: any) => {
    // console.log("API GALLERY SUCCESS");
    if (status === 200 && data) {
      dispatch(action.galleryListSet(data));
    }
  };

  const apiError = () => {
    // console.log("API GALLERY ERROR");
  };

  useEffect(() => {
    apiFriendGallery(id, apiSuccess, apiError);
  }, []);

  if (isAuth)
    return (
      <section className="gallery" role="sectionGallery">
        <div className="gallery__wrapper">
          <LinkActionBack to={`/user/${id}`}>Назад</LinkActionBack>
          <div className="gallery__container">
            <div className="gallery__header">
              <div className="gallery__header-icon">
                <IconGallery />
              </div>
              <div className="gallery__header-content">
                <h2 className="gallery__header-title">Галерея</h2>
                <p className="gallery__header-subtitle">
                  Фотографии <span>{photos && photos.length}</span>
                </p>
              </div>
            </div>

            <div className="gallery__body">
              <div className="gallery__images">
                <PhotoAlbum
                  layout="rows"
                  photos={smallPhotos}
                  onClick={(event, photo, index) => {
                    dispatch(action.mGalleryViewNumberSet(index));
                    dispatch(action.mGalleryViewShow());
                  }}
                  renderPhoto={RenderUserPhoto}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  return <RedirectTo path="/sign-in" />;
};
